/**
 * cdc-lipscore-hide-low.js
 *
 * Hide Lipscore rating widgets whose score is below THRESHOLD (default 3), on product
 * pages (#lipscore-rating) and collection/Boost cards (.lipscore-rating-small).
 * Must be JS: the score only exists in the DOM after Lipscore hydrates client-side, and
 * Lipscore has no built-in "hide below score" setting.
 *
 * Anti-flash / no-shift / fail-open are handled by the CSS + inline gate in theme.liquid.
 * Here we just read the score and tag each widget:
 *   - .cdc-ls-resolved : revealed (set for both outcomes, and by the watchdog)
 *   - .cdc-ls-low      : score < threshold -> hidden (display:none)
 *   - [data-cdc-ls]    : decision finalized (watchdog skips this, so a late score can
 *                        still re-classify a widget the watchdog had revealed)
 */
(function () {
  'use strict';

  // We loaded: cancel the inline fail-open timer and own fail-open via the watchdog. Keeps
  // the gate active so cards lazy-loaded later (infinite scroll) don't flash either.
  if (window.__cdcLsGateTimer) {
    clearTimeout(window.__cdcLsGateTimer);
    window.__cdcLsGateTimer = null;
  }

  var THRESHOLD = (typeof window.CDC_LIPSCORE_MIN_SCORE === 'number')
    ? window.CDC_LIPSCORE_MIN_SCORE
    : 3;
  var SELECTOR = '#lipscore-rating, .lipscore-rating-small';
  var WATCHDOG_MS = 8000;

  function num(v) {
    if (v == null) return null;
    var n = parseFloat(String(v).replace(',', '.'));
    return isNaN(n) ? null : n;
  }

  // Displayed 0–5 score, or null if not hydrated. data-ls-product-rating is on a 0–10
  // scale (e.g. "4" => 2.0 stars), so halve it.
  function readScore(el) {
    var raw = num(el.getAttribute('data-ls-product-rating'));
    return raw === null ? null : raw / 2;
  }

  function process(el) {
    if (el.getAttribute('data-cdc-ls')) return; // already decided
    var score = readScore(el);
    if (score === null) return;                 // not hydrated yet

    var low = score < THRESHOLD;
    if (low) el.classList.add('cdc-ls-low');
    el.classList.add('cdc-ls-resolved');
    el.setAttribute('data-cdc-ls', low ? 'low' : 'ok');
  }

  function processAll() {
    var els = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < els.length; i++) process(els[i]);
  }

  var debounce = null;
  function schedule() {
    if (debounce) clearTimeout(debounce);
    debounce = setTimeout(processAll, 80);
  }

  function start() {
    processAll();

    // Catches Lipscore hydrating (sets data-ls-product-rating, no child added) and Boost
    // re-rendering cards — hence both attributes and childList.
    try {
      new MutationObserver(schedule).observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-ls-product-rating']
      });
    } catch (e) { /* noop */ }

    document.addEventListener('boostPLPProductsLoaded', schedule);
    document.addEventListener('boostSDAppLoaded', schedule);

    // Fail-open: reveal anything we never scored so a missing score can't hide it forever.
    setTimeout(function () {
      var els = document.querySelectorAll(SELECTOR);
      for (var i = 0; i < els.length; i++) {
        if (!els[i].getAttribute('data-cdc-ls')) els[i].classList.add('cdc-ls-resolved');
      }
    }, WATCHDOG_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
